import React from "react";
import GenericDropdown from "@ui-components/Dropdown/GenericDropdown";
import GenericButton from "@ui-components/Button/GenericButton";
import { isGeneralInfoValidCR, isServiceSelectionValid } from "../../utils/tickets";
import { KontrolEdgeServiceSelection } from "../shared/KontrolEdgeServiceSelection";

import type { ServiceItem } from "../../utils/tickets";
import { UseTopicsLoaderReturn } from "settings/support/hooks/useTopicsLoader";
import { UseChangeRequestFormReturn } from "settings/support/hooks/useChangeRequestForm";

interface ServiceSelectionTabProps {
  isKontrolEdge: boolean;
  topicsLoader: UseTopicsLoaderReturn;
  form: UseChangeRequestFormReturn;
  isPartnerView: boolean;
  uniqueCustomers: Array<{ id: number; nameDisplay: string }>;
  filteredServiceItems: ServiceItem[];
  onCustomerSelect: (customerNameDisplay: string) => void;
  onServiceSelect: (selectedLabels: string[]) => void;
  onSelectTwoLevel: (twoLabel: string) => void;
  onNext: () => void;
}

export const ServiceSelectionTab: React.FC<ServiceSelectionTabProps> = ({
  isKontrolEdge,
  topicsLoader,
  form,
  isPartnerView,
  uniqueCustomers,
  filteredServiceItems,
  onCustomerSelect,
  onServiceSelect,
  onSelectTwoLevel,
  onNext,
}) => {
  return (
    <div className="space-y-4 text-sm text-gray-700">
      {isKontrolEdge && (
        <KontrolEdgeServiceSelection
          isPartnerView={isPartnerView}
          uniqueCustomers={uniqueCustomers}
          filteredServiceItems={filteredServiceItems}
          selectedCustomerId={form.formState.selectedCustomerId}
          selectedCustomerNameDisplay={
            form.formState.selectedCustomerNameDisplay
          }
          selectedServiceLabels={form.formState.selectedServiceLabels}
          onCustomerSelect={onCustomerSelect}
          onServiceSelect={onServiceSelect}
        />
      )}

      {!isKontrolEdge && (
        <>
          <div className="flex flex-col sm:flex-row gap-4">
            <div className="w-full sm:w-1/2">
              <label className="block mb-1 font-medium text-semantic-text-secondary">
                Topic <span className="text-red-500">*</span>
              </label>
              <GenericDropdown
                items={topicsLoader.topics.map((t) => t.label)}
                value={topicsLoader.selectedTopicLabel}
                onSelect={topicsLoader.handleSelectTopic}
                defaultLabel="No options available"
                minWidthClass=""
                maxWidthClass=""
                widthClass="w-full"
                fixedPosition={true}
                dropdownMaxHeightClass="max-h-48"
              />
            </div>
            <div className="w-full sm:w-1/2">
              <label className="block mb-1 font-medium text-semantic-text-secondary">
                Specify your request <span className="text-red-500">*</span>
              </label>
              <GenericDropdown
                items={topicsLoader.twoLevelOptions.map((t) => t.label)}
                value={topicsLoader.selectedTwoLevelLabel}
                onSelect={onSelectTwoLevel}
                defaultLabel="No options available"
                minWidthClass=""
                maxWidthClass=""
                widthClass="w-full"
                fixedPosition={true}
                dropdownMaxHeightClass="max-h-48"
              />
            </div>
          </div>
        </>
      )}
      <div className="flex justify-end pt-2">
        <GenericButton
          label="Next"
          variant="brand"
          onClick={onNext}
          disabled={
            isKontrolEdge
              ? !isServiceSelectionValid(
                  isPartnerView,
                  form.formState.selectedCustomerId,
                  form.formState.selectedServiceIds
                )
              : !isGeneralInfoValidCR(
                  isKontrolEdge,
                  topicsLoader.selectedTopicLabel,
                  topicsLoader.selectedTwoLevelLabel
                )
          }
        />
      </div>
    </div>
  );
};
